<template>
  <div>
    <h4
      v-if="title"
      class="subhead-bold-16 d-flex align-center mb-4"
    >
      {{ title }}
      <tm-help-icon-tooltip
        v-if="tooltip || $slots.tooltip"
        icon="help_outline"
        icon-size="small"
      >
        <slot name="tooltip">{{ tooltip }}</slot>
      </tm-help-icon-tooltip>
    </h4>

    <div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import TmHelpIconTooltip from '@/components/shared/TmHelpIconTooltip.vue'

defineProps<{
  title?: string
  tooltip?: string
}>()
</script>
